export default __webpack_public_path__ + "static/media/Paypal.e08fd192.svg";